module.exports = (__parcel__import__("./" + "profileGrid.fc712fd9.js")).then(() => parcelRequire('isjnC'));